import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Import FontAwesome icons
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { 
  faCheck, faPhone, faEnvelope, faMapMarkerAlt, faPhoneAlt, 
  faMoneyBillWave, faClock, faFileContract, faHandHoldingDollar, 
  faArrowRight, faQuoteLeft, faStar, faFile, faHandshake, 
  faClipboardCheck, faLightbulb, faDollarSign, faShieldAlt, 
  faChartLine, faUsers, faLandmark, faPaperPlane, faRulerCombined, 
  faTree, faMountain, faPercent
} from '@fortawesome/free-solid-svg-icons';

// Add FontAwesome icons to library
library.add(
  fab, faCheck, faPhone, faEnvelope, faMapMarkerAlt, faPhoneAlt,
  faMoneyBillWave, faClock, faFileContract, faHandHoldingDollar,
  faArrowRight, faQuoteLeft, faStar, faFile, faHandshake, 
  faClipboardCheck, faLightbulb, faDollarSign, faShieldAlt,
  faChartLine, faUsers, faLandmark, faPaperPlane, faRulerCombined,
  faTree, faMountain, faPercent
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
